import React, { useMemo, useState } from 'react';
import { pathgen } from 'object-path-generator';
import { Typography, ConfirmationModal } from 'seagull';
import { AdvancedSettingsControl } from "../ServiceAdvancedSettings/AdvancedSettingsControl/AdvancedSettingsControl";
import { AdvancedSettingCategory, ADVANCED_SETTING_CATEGORY_MAP } from "../ServiceAdvancedSettings/ServiceAdvancedSettings.types";
import styles from "./ServiceAdvancedSettingsModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const {
  ServiceAdvancedSettingsModalTestIds
} = pathgen();
export const ServiceAdvancedSettingsModal = _ref => {
  let {
    onClose,
    onSave,
    availableSettings
  } = _ref;
  const [checkedSettings, setCheckedSettings] = useState(() => new Set(availableSettings.filter(s => s.isActive).map(s => s.type)));
  const settingsByCategory = useMemo(() => {
    const grouped = {
      [AdvancedSettingCategory.Pricing]: [],
      [AdvancedSettingCategory.Billing]: [],
      [AdvancedSettingCategory.Integrations]: []
    };
    availableSettings.forEach(setting => {
      const category = ADVANCED_SETTING_CATEGORY_MAP[setting.type];
      grouped[category].push(setting);
    });
    return grouped;
  }, [availableSettings]);
  const categories = [AdvancedSettingCategory.Pricing, AdvancedSettingCategory.Billing, AdvancedSettingCategory.Integrations];
  const toggleSetting = settingType => {
    setCheckedSettings(prev => {
      const next = new Set(prev);
      if (next.has(settingType)) {
        next.delete(settingType);
      } else {
        next.add(settingType);
      }
      return next;
    });
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Advanced settings",
    onCloseButtonClick: onClose,
    "data-testid": ServiceAdvancedSettingsModalTestIds.Root(),
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: () => onSave(checkedSettings),
    onSecondaryButtonClick: onClose,
    width: "600px",
    content: /*#__PURE__*/_jsx(_Fragment, {
      children: categories.map(category => {
        const settings = settingsByCategory[category];
        if (settings.length === 0) return null;
        return /*#__PURE__*/_jsxs("div", {
          className: styles.category,
          "data-testid": ServiceAdvancedSettingsModalTestIds.Category(category),
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "secondary",
            children: category
          }), settings.map(setting => /*#__PURE__*/_jsx(AdvancedSettingsControl, {
            isReadOnly: false,
            info: setting.info,
            label: setting.label,
            checked: checkedSettings.has(setting.type),
            testid: ServiceAdvancedSettingsModalTestIds.Setting(category, setting.type),
            disabled: setting.disabled,
            disabledTooltip: setting.disabledTooltip,
            onChange: () => toggleSetting(setting.type)
          }, setting.type))]
        }, category);
      })
    })
  });
};